<template>
  <div class="fit">
    <q-card class="column fit">
      <googleMaps
        :center="{ lng: 172.64715, lat: -43.5781 }"
        :zoom="6"
        :upperLimit="upperLimit"
        :lowerLimit="lowerLimit"
        mapType="roadmap"
        :normalizedData="normalizedData"
        :profileData="currentZoomScanData"
        :overlayAllData="overlayAllData"
        :polyline="line"
        :dot="dot"
        :showRangeCircles="false"
        :options="{
          zoomControl: false,
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: true,
        }"
        style="height: 100%; width: 100%; position: relative; z-index: 1"
        ref="gmapReport"
        @dotClicked="dotClicked"
        @zoomLevelChanged="handleNewZoomLevel"
      >
      </googleMaps>
    </q-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import googleMaps from "@/components/googleMaps/googleMaps.vue";
import moment from "moment";

export default {
  components: { googleMaps },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentZoomScanData",
      "currentZoomScanDataLoading",
      "currentZoom",
      "currentViewedReports",
    ]),
  },
  props: {
    source: String,
  },
  data: () => ({
    coords: {
      lng: 172.64715,
      lat: -43.5781,
    },
    selectedSuveys: [],
    showSurveyList: false,

    dot: true,
    line: true,
    upperLimit: 12,
    lowerLimit: 6,
    normalizedData: [],
    overlayAllData: true,
  }),
  mounted() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(this.setPosition, this.runError);
    }
  },
  watch: {
    currentZoomScanData: function () {
      this.updateNormalizationData();
      this.upperLimit = this.currentZoomScanData[0].upperLimit;
      this.lowerLimit = this.currentZoomScanData[0].lowerLimit;
    },
    currentMapIndex: function () {
      this.updateNormalizationData();
    },
  },
  methods: {
    setPosition(position) {
      this.coords.lat = position.coords.latitude;
      this.coords.lng = position.coords.longitude;
      this.$refs.gmapReport.panToLocation({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });
    },
    init() {},
    updateCenterPOS(position) {
      this.$refs.gmapReport.panToLocation(position);
    },
    runError(error) {
      this.$q.notify({
        position: "top-right",
        type: "error",
        message: error.message,
      });
    },

    dotClicked(point) {
      // console.log(point);
    },
    handleNewZoomLevel(zoom) {
      if (
        (zoom > this.currentZoom || zoom <= this.currentZoom - 3) &&
        zoom <= 18
      ) {
        clearTimeout(this.zoomDebounce);
        this.zoomDebounce = setTimeout(() => {
          this.$store.dispatch("loadSurveyScanDataForZoom", {
            idList: this.currentViewedReports,
            zoom: zoom,
            disableNormalization: true,
          });
        }, 1000);
      }
    },
    updateNormalizationData() {
      setTimeout(() => {
        this.normalizedData = this.currentZoomScanData.normalizedData;
      }, 500);
    },
  },
};
</script>

<style>
#reportSlider > .q-slider__track-container {
  background-color: rgba(0, 0, 0, 0) !important;
}
</style>
